// ############# GET ACTIVE ##############
const GET_ACTIVE_GALLERIES = "/gallaries/public";

export const gallaryEndpoints = { GET_ACTIVE_GALLERIES };
